var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('CommonAlert',{attrs:{"show":_vm.show,"text":_vm.$t('alerts.event_success'),"border":"left","type":"success"},on:{"close":_vm.handleClose}})}
var staticRenderFns = []

export { render, staticRenderFns }